export type ProjectKey = string;
export const toProjectKey = (key: string): ProjectKey => key;

export type BoardId = string;
export const toBoardId = (id: string): BoardId => id;

export type ProjectId = string;
export const toProjectId = (id: string): ProjectId => id;

export const CLASSIC = 'CLASSIC' as const;
export const NEXTGEN = 'NEXTGEN' as const;

export type RoadmapType = typeof CLASSIC | typeof NEXTGEN;
